export default __webpack_public_path__ + "static/media/Uppsala.fd10776f.svg";